<nb-card>
    <nb-card-header>
        {{ confirmationData.title }}

        <button ghost status="basic" nbButton (click)="cancel()">
            <nb-icon icon="close" status="basic"></nb-icon>
        </button>
    </nb-card-header>

    <nb-card-body>
        <ng-container *ngIf="confirmationData.innerHTML; else textMessage">
            <span [ngClass]="confirmationData.status" [innerHTML]="confirmationData.message"></span>
        </ng-container>
        <ng-template #textMessage>
            <span [ngClass]="confirmationData.status">{{ confirmationData.message }}</span>
        </ng-template>
    </nb-card-body>

    <nb-card-footer>
        <button nbButton fullWidth status="basic" (click)="cancel()">
            {{ confirmationData.cancelText ? confirmationData.cancelText : "Cancel" }}
        </button>

        <button nbButton fullWidth status="primary" class="ml-3" (click)="confirm()">
            {{ confirmationData.confirmText ? confirmationData.confirmText : "Confirm" }}
        </button>
    </nb-card-footer>
</nb-card>
